import React, { useState, useEffect } from 'react';

const NAV_LINKS = [
  { label: 'About',      href: '#about' },
  { label: 'Experience', href: '#experience' },
  { label: 'Skills',     href: '#skills' },
  { label: 'Projects',   href: '#projects' },
  { label: 'Contact',    href: '#contact' },
];

const NavBar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
      const total = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(total > 0 ? (window.scrollY / total) * 100 : 0);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`navbar${scrolled ? ' scrolled' : ''}`}>
      <div className="scroll-progress-bar" style={{ width: `${progress}%` }} />
      <a href="#hero" className="nav-logo">HS</a>
      <div className="nav-links">
        {NAV_LINKS.map(({ label, href }) => (
          <a key={href} href={href} className="nav-link">{label}</a>
        ))}
      </div>
      <a href="Harsh-Resume.pdf" download className="nav-resume-btn" aria-label="Download resume">
        Resume
      </a>
    </nav>
  );
};

export default NavBar;
